export enum NotificationType {
  MIN_SOCK,
  TICKET_COLLECTED,
  ARTICLE_REPORT,
  USER_MESSAGE,
  APPLICANT_COMMENT
}
